export default __webpack_public_path__ + "static/media/Icon_record.e05ab49f.svg";